import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { eventCashFlowInitialValues, IEventCashFlowForm } from 'components/organisms/forms/event-cash-flow/EventCashFlowForm';
import { FormikHelpers } from 'formik';
import { useMutateOptions } from 'hooks';
import { useParamId } from 'hooks/useParamId';
import { eventCashFlowFormToQuery } from 'middleware/event-cash-flow/eventCashFlowFormToQuery';
import { useTranslation } from 'react-i18next';
import { PiReceiptFill, PiX } from 'react-icons/pi';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCreateEventCost } from 'services/events/cost';
import { ICreateEventCost } from 'services/events/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

const CreateEventCost = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const eventId = useParamId('event');
  const createEventCost = useCreateEventCost();

  const mutateOptions = useMutateOptions<IEventCashFlowForm>();

  const onCreateEventCost = async (
    values: IEventCashFlowForm,
    helpers: FormikHelpers<IEventCashFlowForm>
  ) => {
    const eventCostData = eventCashFlowFormToQuery(values, 'cost') as ICreateEventCost;
    
    await createEventCost.mutateAsync(eventCostData, {
      ...mutateOptions(helpers),
      onSuccess: () => navigate(`/event/${eventId}/balance`),
    });
  };

  return (
    <Form.EventCashFlow
      i18nextPrefix='event-cost'
      initialValues={{
        ...eventCashFlowInitialValues,
        eventId: eventId,
      }}
      onSubmit={onCreateEventCost}
      customBackItem={
        <Button type='button' onlyIcon onClick={() => navigate(`/event/${eventId}/balance`)}>
          <Button.Description description={t('button.cancel')} />

          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <Button type='submit' variant={BUTTON_VARIANT.submit}>
          <Button.Text text={t('button.create')} />
          <Button.Icon icon={<PiReceiptFill />} />
        </Button>
      }
    />
  );
};

export default CreateEventCost; 